import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './MinhasMensagens.css'

const MinhasMensagens = () => {
    const [mensagens, setMensagens] = useState([])

    useEffect(() => {
        const url = '/api/mensagem/getMensagensEtica'
        const user = localStorage.idE
        axios.post(url, { user })
            .then(res => {
                setMensagens(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-envelope-exclamation iconeBuscaPed"></i>
                MENSAGEM
            </div>
            <div className="overFlow">
                <div className="formMinhasMensagens">
                    <label className="labelMinhasMensagens">Minhas Mensagens</label>
                    <div className="minhasMensagensHeader">
                        <div className="minhasMensagensElementHeader">REMETENTE</div>
                        <div className="minhasMensagensElementHeader">DATA</div>
                        <div className="minhasMensagensElementHeader">ABRIR</div>
                    </div>
                    {RenderMensagens()}
                </div>
            </div>
        </React.Fragment>
    )

    function RenderMensagens() {
        if (mensagens.length > 0) {
            let tabela = []
            mensagens.map(mensagem => {
                if (!mensagem.arquivada) {
                    tabela.push(
                        <div className="minhasMensagensBody">
                            <div className="minhasMensagensElementBody">{mensagem.usuarioFonte}</div>
                            <div className="minhasMensagensElementBody">{mensagem.data.slice(0, 10)}</div>
                            <div className="minhasMensagensElementBody">
                                <a href={`/etica/mensagem/${mensagem._id}`}>
                                    <i className="bi bi-folder-symlink iAbrirProcesso"></i>
                                </a>
                            </div>
                        </div>
                    )
                }
            })
            return tabela
        }
    }
}

export default MinhasMensagens